import { styled, IconButton, Typography } from "@mui/material";
const ButtonContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center"
}));
const CountButton = styled(IconButton)(() => ({
  height: "24px",
  "&&.Mui-disabled": {
    opacity: "0.38"
  }
}));
const Count = styled(Typography)(() => ({
  cursor: "default",
  fontSize: "16px",
  lineHeight: "22px",
  display: "flex",
  alignItems: "center",
  letterSpacing: "0.5px"
}));
export {
  ButtonContainer,
  Count,
  CountButton
};
